import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ProductView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerCatalog } from "@/lib/query/core/invalidation";
import { queryKeys } from "@/lib/query/core/query-keys";

type UpdateProductImagesInput = {
  storeSlug: string;
  productId: string;
  images: Array<{
    imageId: string;
    objectKey: string;
    sortOrder: number;
    useBgRemoved?: boolean;
  }>;
};

export function useUpdateProductImagesMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: UpdateProductImagesInput) => {
      const { storeSlug, productId, ...body } = input;
      void storeSlug;
      return apiJsonClient<ProductView>(endpoints.seller.productImagesById(productId), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
    },
    onSuccess: async (_data, variables) => {
      await invalidateSellerCatalog(queryClient, variables.storeSlug);
      await queryClient.invalidateQueries({
        queryKey: queryKeys.seller.productById(variables.storeSlug, variables.productId),
        exact: true,
      });
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
